import React from 'react';

interface PrintValidatorContext {
    setPrintValidator?: ((v: (() => string[]) | undefined) => void) | undefined;
}

const PrintValidatorContext = React.createContext<PrintValidatorContext>({
    setPrintValidator: undefined,
});

export default PrintValidatorContext;
